import { formatFlightDuration } from '../util/formatting.js';
import constants from '../util/constants.js';
import i18n from 'shared/locale/i18n.js';

export const bestOfferTypes = ['AGONY', 'PRICE', 'DURATION', 'CO2'];

export function mapBestOfferType(type) {
    switch (type) {
        case 'PRICE':
            return 'priceAmount_asc';
        case 'DURATION':
            return 'tripDuration_asc';
        case 'AGONY':
            return 'agony_asc';
        case 'CO2':
            return 'tonsOfCo2_asc';
        default:
            return type;
    }
}

function offerActive(type, sortCriteria) {
    const isBest = type === 'AGONY' && sortCriteria === constants.SORT_BY_BEST;
    const isDuration = type === 'DURATION' && sortCriteria === constants.SORT_BY_DURATION;
    const isPrice = type === 'PRICE' && sortCriteria === constants.SORT_BY_PRICE;
    const isCo2 = type === 'CO2' && sortCriteria === constants.SORT_BY_CO2;
    return isBest || isDuration || isPrice || isCo2;
}

function formatAirports(airports) {
    let airportList = [];
    if (!airports.secondOrigin && !airports.secondDestination) {
        airportList = adjustAirportOrder({ origin: airports.origin, destination: airports.destination });
    } else {
        const push = item => (item ? airportList.push(item) : null);
        push(airports.origin);
        push(airports.destination);
        push(airports.secondOrigin);
        push(airports.secondDestination);
    }
    return airportList.length > 0 ? airportList.join(', ').replace(/,([^,]*)$/, ` ${i18n.t('common:misc.and')}$1`) : airportList;
}

function adjustAirportOrder(airports) {
    let formattedAirportList = [];
    if (airports.origin && airports.origin.length > 0) {
        formattedAirportList.push(airports.origin[0]);
    }
    if (airports.destination) {
        formattedAirportList = formattedAirportList.concat(airports.destination);
    }
    if (airports.origin && airports.origin.length > 1) {
        formattedAirportList = formattedAirportList.concat(airports.origin.slice(1));
    }
    return formattedAirportList;
}

function enrichSupremeOffer(offer) {
    offer = enrichOffer(offer, 'SUPREME');
    offer.supremeAirports = offer.airports;
    if (offer.airports) {
        offer.airportsFormatted = formatAirports(offer.airports);
    }
    return offer;
}

function enrichOffer(offer, type, sortCriteria) {
    offer.title = i18n.t(`result:bestOffer.${type.toLowerCase()}`);
    offer.active = offerActive(type, sortCriteria);
    offer.price = offer.price ? i18n.t('common:currency.default', { value: offer.price }) : '';
    offer.type = type;
    if (Array.isArray(offer.durations) && offer.durations.length > 0) {
        let dur = `${formatFlightDuration(offer.durations[0])}`;
        if (offer.durations.length > 1) {
            dur = `${dur} ${i18n.t('common:misc.and')} ${formatFlightDuration(offer.durations[1])}`;
        }
        offer.duration = dur;
    }
    return offer;
}

function allTypesHavePayload(data) {
    return data && bestOfferTypes.every(type => data[type] && Object.keys(data[type]).length > 0);
}

export function mapBestOffers(data, sortCriteria) {
    return allTypesHavePayload(data) ? bestOfferTypes.map(type => enrichOffer(data[type], type, sortCriteria)) : null;
}

export function supremeOffer(data) {
    return data && data.SUPREME ? enrichSupremeOffer(data.SUPREME) : null;
}
